export default __webpack_public_path__ + "static/media/Banner - AirLockz - Cobalt Blue.19be3295.jpg";